import { render, staticRenderFns } from "./PaylahOnTile.vue?vue&type=template&id=ceed6a58&scoped=true&"
import script from "./PaylahOnTile.vue?vue&type=script&lang=js&"
export * from "./PaylahOnTile.vue?vue&type=script&lang=js&"
import style0 from "./PaylahOnTile.vue?vue&type=style&index=0&id=ceed6a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceed6a58",
  null
  
)

export default component.exports